export default "__VITE_ASSET__c9a9086f__"